<template>
  <div class="trainee-list-modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="trainee-list-modal" @click.stop>
        <div class="modal-content">
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <h2>Edit Assessment Task ID: {{ newAssessmentTask.assessment_task_id }}</h2>

          <div class="add">
            <form @submit.prevent="updateAssessmentTask">
              <div class="form-group">
                <label for="chapt-no">Chapter No:</label>
                <input type="text" class="form-control rounded" id="chapt-no" name="chapt-no"
                  v-model="newAssessmentTask.chapt_no" />
              </div>
              <div class="form-group">
                <label for="task-no">Task No:</label>
                <input type="text" class="form-control rounded" id="task-no" name="task-no"
                  v-model="newAssessmentTask.task_no" />
              </div>
              <div class="form-group">
                <label for="category">Category:</label>
                <select class="form-control rounded" id="category" name="category" v-model="newAssessmentTask.category">
                  <option value="" disabled selected>Select Category</option>
                  <option value="B1">B1</option>
                  <option value="B2">B2</option>
                  <option value="B1 B2">B1 B2</option>
                </select>
              </div>
              <div class="form-group">
                <label for="question">Question:</label>
                <input type="text" class="form-control rounded" id="question" name="question"
                  placeholder="Enter Task Question" v-model="newAssessmentTask.question" />
              </div>
              <div class="form-group">
                <label for="assessment_type">Assessment Type:</label>
                <select class="form-control rounded" id="assessment_type" name="assessment_type"
                  v-model="newAssessmentTask.assessment_type">
                  <option value="" disabled selected>Select Assessment Type</option>
                  <option value="airframe">AirFrame</option>
                  <option value="powerplant">PowerPlant</option>
                  <option value="avionics">Avionics</option>
                  <option value="electrical">Electrical</option>
                </select>
              </div>
              <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                <div v-if="errorMessage">{{ errorMessage }}</div>
              </div>
              <div>
                <button class="btn btn-primary rounded" type="submit" style="margin-top: 10px;">Update Task</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      allAssessmentTasks: [],
      instructors: [],
      products: [],
      assessment_tasks: [],
      newAssessmentTask: {
        chapt_no: '',
        task_no: '',
        category: '',
        question: '',
        assessment_type: '',
      },
      showAlert: false,
      currentTime: '',
      errorMessages: {},
      errorMessage: '',
      productSelected: false,
      taskSelected: false,
      showTraineeList: false,
      isVisible: false,
    };
  },
  methods: {
    async updateAssessmentTask() {
      try {
        const assessment_task_id = parseInt(localStorage.getItem('assessment_task_id'));

        const taskExists = this.allAssessmentTasks.some(assessment_task =>
          String(assessment_task.task_no).trim() === String(this.newAssessmentTask.task_no).trim() &&
          String(assessment_task.chapt_no).trim() === String(this.newAssessmentTask.chapt_no).trim() &&
          assessment_task.assessment_task_id !== assessment_task_id // Exclude the current task
        );
        if (taskExists) {
          this.errorMessage = "An Assessment task with this Task No and Chapter No already exists.";
          this.showAlert = true;
          return;
        }

        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Proceed with the update request if no duplicates are found
        const response = await axios.put(
          `/api/assessment_tasks/${assessment_task_id}`,
          {
            chapt_no: this.newAssessmentTask.chapt_no,
            task_no: this.newAssessmentTask.task_no,
            category: this.newAssessmentTask.category,
            question: this.newAssessmentTask.question,
            assessment_type: this.newAssessmentTask.assessment_type,
          },
          { headers }
        );

        if (response.status === 200) {
          window.alert('Assessment Task updated successfully');
          this.assessment_tasks.push(response.data);  // Update the local Assessment Tasks list
          this.newAssessmentTask = {
            chapt_no: '',
            task_no: '',
            category: '',
            question: '',
            assessment_type: '',
          };
          this.errorMessage = '';
          this.showAlert = false;
        }
        await this.fetchAssessmentTasks();
        window.location.reload();
      } catch (error) {
        if (error.isOffline === true) {
          this.$emit('close');
          return;
        }
        console.error('Error updating Task:', error.response);


        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while updating the task.' + error.response.data.message;
        }

        this.showAlert = true;
      }
    },
    async fetchAssessmentTasks() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.display('unauthorized');
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get(`/api/assessment_tasks`, { headers });
        console.log('assessment task response')
        console.log(response);

        if (response.status === 200) {
          this.allAssessmentTasks = response.data;
        }
      } catch (error) {
        console.error('Error retrieving tasks:', error);
        // Handle error
      }
    },
    goBack() {
      this.$router.push({ name: 'ViewAssessmentTasks' });
    },
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    getAssessmentTaskData(assessment_task_id) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        axios.get(`/api/assessment_tasks/${assessment_task_id}`, { headers })
          .then(res => {
            this.newAssessmentTask = res.data;
            console.log(res.data);
          });
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
  },
  async mounted() {
    this.isVisible = true;
    this.getAssessmentTaskData(localStorage.getItem('assessment_task_id'));
    this.fetchAssessmentTasks();
  },
}
</script>

<style scoped>
.trainee-list-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Ensure the modal is on top of other content */
}

/* Style your modal content */
.trainee-list-modal {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  width: 80%;
  max-width: 800px;
  /* Limit the maximum width of the modal */
  padding: 20px;
  position: relative;
  max-height: 95%;
}

.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
}

.add button {
  width: 200px;
  height: 40px;
  margin-top: 50px;
  margin-bottom: 20px;
  border: 1px solid rgb(0, 96, 134);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.add {
  margin-top: 0;
  height: 90%;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

h2 {
  margin-top: 10px;
  font-size: 30px;
  margin-bottom: 40px;
}

.form-control.rounded {
  height: 40px;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.form-group label {
  width: 150px;
  margin-right: 50px;
  text-align: right;
  margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
  flex: 1;
  width: auto;
  margin-left: 0;
  margin-bottom: 0px;
}

#chapt-no, #task-no {
  flex: 0 0 80px; /* don't grow, don't shrink, fixed 100px */
  width: 80px;
}

.form-control {
  border-radius: 5px;
}

.form-control#start_date .form-control#end_date {
  border-radius: 5px;
  width: 25%;
  margin-left: 100px;
  margin-right: 45%;
}

h1 {
  margin-bottom: 20px;
}

.alert-danger {
  color: #ff0019;
  background-color: #f8d7da;
  border: 1px solid #e6b0b6;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}
</style>